import { getApiBaseUrl } from '../../../utils/apiBase';
import type { ViewManagerFetchResponse } from '../../../types';

const fetchViewManagerNotifications = async (
  recipientUserId: number,
  limit = 20,
  offset = 0,
): Promise<ViewManagerFetchResponse | undefined> => {
  try {
    const params = new URLSearchParams({
      recipient_user_id: String(recipientUserId),
      limit: String(limit),
      offset: String(offset),
    });

    const apiBase = getApiBaseUrl();
    const response = await fetch(`${apiBase}/api/getNotificationsFromViewmanager?${params.toString()}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch View Manager notifications: ${response.status}`);
    }

    const data: ViewManagerFetchResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch View Manager notifications:', error);
  }
};

export default fetchViewManagerNotifications;
